// Label/heading/CTA translations. Body paragraphs remain in English.

export const LANGUAGES = [
  { code: 'en', label: 'EN', name: 'English',    flag: '🇺🇸' },
  { code: 'es', label: 'ES', name: 'Español',   flag: '🇪🇸' },
  { code: 'pt', label: 'PT', name: 'Português', flag: '🇧🇷' },
];

const t = {
  en: {
    nav: {
      biography: 'Biography',
      experience: 'Experience',
      practice: 'Practice Areas',
      writing: 'Writing Samples',
      credentials: 'Credentials',
      organizations: 'Organizations',
      retainr: 'RetainR & Media',
      contact: 'Contact',
    },
    intro: {
      credential: 'Immigration & Family Law · Removal Defense',
      tagline: 'The Architect of Advocacy',
      skip: 'Skip',
      enter: 'Enter',
      soundOn: 'Sound On',
      soundOff: 'Sound Off',
      soundHint: 'Best experienced with sound',
    },
    hero: {
      label: 'Immigration & Family Law',
      cta: 'View Writing Samples',
      scroll: 'Scroll',
      quickAccess: 'Quick Access',
      cards: {
        biography: 'Biography',
        writing: 'Writing Samples',
        resume: 'Resume / CV',
        contact: 'Contact',
      },
    },
    bio: {
      label: 'Biography',
      heading: 'The Case for Deliberate Practice',
      tagsLabel: 'Specialties',
      languagesLabel: 'Languages',
    },
    experience: {
      label: 'Legal Experience',
      heading: 'A Docket Built on Real Cases',
      subheading: 'Twenty-four Immigration Court appearances, more than 500 orders drafted for the 15th Judicial Circuit, and prior work in a District Attorney’s office and a Governor’s policy shop.',
    },
    practice: {
      label: 'Practice Areas',
      heading: 'Where the Work Lives',
      subheading: 'Four interwoven disciplines, one unified method of advocacy.',
    },
    writing: {
      label: 'Writing Samples',
      heading: 'Drafted. Revised. Defended.',
      subheading: 'A selection of legal writing — motions, memoranda, and appellate briefs.',
      download: 'Download',
      comingSoon: 'Coming Soon',
      featured: 'Featured',
    },
    credentials: {
      label: 'Credentials & Training',
      heading: 'Education, Certifications & Skills',
      education: 'Education',
      trainings: 'Trainings & Certifications',
      skills: 'Legal Skills',
      litigation: 'Removal Defense & Litigation',
      research: 'Research & Writing',
      clientAdvocacy: 'Client Advocacy',
    },
    orgs: {
      label: 'Organizations & Pro Bono',
      heading: 'Service Beyond the Casebook',
      memberships: 'Memberships',
      proBono: 'Pro Bono Commitments',
      types: {
        Professional: 'Professional',
        Academic: 'Academic',
        Advocacy: 'Advocacy',
      },
    },
    footer: {
      label: 'Engage Counsel',
      heading: 'Retain Thoughtful Representation',
      emailLabel: 'Direct Correspondence',
      phoneLabel: 'Telephone',
      locationLabel: 'Offices',
      roleLabel: 'Practice',
      roleValue: 'Immigration & Family Law',
      barLabel: 'Founder',
      barValue: 'RetainR — Legal-Tech Platform',
      followLabel: 'Courtside with KC',
      contactCta: 'Send a Message',
      rights: 'All Rights Reserved',
    },
    contact: {
      label: 'Contact',
      heading: 'Start the Conversation',
      subheading: 'Immigration, family law, RetainR, or media — every message is read personally.',
      directLabel: 'Direct Correspondence',
      responseNote: 'Responses typically within one business day.',
      name: 'Full Name',
      email: 'Email Address',
      phone: 'Telephone (optional)',
      matter: 'Nature of Inquiry',
      matters: {
        immigration: 'Immigration Law',
        family: 'Family Law',
        retainr: 'RetainR',
        media: 'Media / Speaking',
        other: 'Other',
      },
      message: 'Your Message',
      messagePlaceholder: 'Briefly describe your matter or request…',
      send: 'Send Message',
      sending: 'Sending…',
      successTitle: 'Message Received',
      successBody: 'Thank you — your message has been delivered to kenneth@KCRedding.com.',
      another: 'Send another message',
      error: 'Something went wrong. Please try again or email directly.',
    },
    retainr: {
      label: 'Founder · Legal Technology',
      heading: 'Prepare Your Case Before You Retain a Lawyer',
      featuresLabel: 'What RetainR Does',
      mattersLabel: 'Built Around',
      visit: 'Visit RetainR.com',
      founderNote: 'Founded by Kenneth Christopher “KC” Redding',
      mediaLabel: 'Courtside with KC',
      mediaHeading: 'The Law, Explained From the Courtside',
      mediaSub: 'Follow @CourtsidewithKC across Instagram, YouTube, and TikTok for plain-language legal insight on immigration, family law, and life in the courtroom.',
      follow: 'Follow',
    },
    resumeChoose: 'Choose a resume',
  },
  es: {
    nav: {
      biography: 'Biografía',
      experience: 'Experiencia',
      practice: 'Áreas de Práctica',
      writing: 'Muestras de Redacción',
      credentials: 'Credenciales',
      organizations: 'Organizaciones',
      retainr: 'RetainR y Medios',
      contact: 'Contacto',
    },
    intro: {
      credential: 'Inmigración y Derecho de Familia · Defensa de Deportación',
      tagline: 'El Arquitecto de la Abogacía',
      skip: 'Omitir',
      enter: 'Entrar',
      soundOn: 'Sonido Activado',
      soundOff: 'Sonido Apagado',
      soundHint: 'Mejor experiencia con sonido',
    },
    hero: {
      label: 'Inmigración y Derecho de Familia',
      cta: 'Ver Muestras de Redacción',
      scroll: 'Desplazar',
      quickAccess: 'Acceso Rápido',
      cards: {
        biography: 'Biografía',
        writing: 'Muestras',
        resume: 'Currículum',
        contact: 'Contacto',
      },
    },
    bio: {
      label: 'Biografía',
      heading: 'El Caso por la Práctica Deliberada',
      tagsLabel: 'Especialidades',
      languagesLabel: 'Idiomas',
    },
    experience: {
      label: 'Experiencia Jurídica',
      heading: 'Un Historial Construido con Casos Reales',
      subheading: 'Veinticuatro comparecencias ante el tribunal de inmigración, más de 500 órdenes redactadas para el 15° Circuito Judicial y experiencia previa en una fiscalía de distrito y en la oficina de políticas de un gobernador.',
    },
    practice: {
      label: 'Áreas de Práctica',
      heading: 'Donde Vive el Trabajo',
      subheading: 'Cuatro disciplinas entrelazadas, un método unificado de defensa.',
    },
    writing: {
      label: 'Muestras de Redacción',
      heading: 'Redactado. Revisado. Defendido.',
      subheading: 'Una selección de redacción jurídica — mociones, memorandos y escritos de apelación.',
      download: 'Descargar',
      comingSoon: 'Próximamente',
      featured: 'Destacado',
    },
    credentials: {
      label: 'Credenciales y Formación',
      heading: 'Educación, Certificaciones y Habilidades',
      education: 'Educación',
      trainings: 'Formaciones y Certificaciones',
      skills: 'Habilidades Legales',
      litigation: 'Defensa de Deportación y Litigio',
      research: 'Investigación y Redacción',
      clientAdvocacy: 'Defensa del Cliente',
    },
    orgs: {
      label: 'Organizaciones y Pro Bono',
      heading: 'Servicio Más Allá del Aula',
      memberships: 'Membresías',
      proBono: 'Compromisos Pro Bono',
      types: {
        Professional: 'Profesional',
        Academic: 'Académica',
        Advocacy: 'Defensa',
      },
    },
    footer: {
      label: 'Contratar Abogado',
      heading: 'Obtenga una Representación Reflexiva',
      emailLabel: 'Correspondencia Directa',
      phoneLabel: 'Teléfono',
      locationLabel: 'Oficinas',
      roleLabel: 'Práctica',
      roleValue: 'Inmigración y Derecho de Familia',
      barLabel: 'Fundador',
      barValue: 'RetainR — Plataforma Legal-Tech',
      followLabel: 'Courtside with KC',
      contactCta: 'Enviar un Mensaje',
      rights: 'Todos los Derechos Reservados',
    },
    contact: {
      label: 'Contacto',
      heading: 'Inicie la Conversación',
      subheading: 'Inmigración, derecho de familia, RetainR o medios — cada mensaje se lee personalmente.',
      directLabel: 'Correspondencia Directa',
      responseNote: 'Respuesta habitual en un día hábil.',
      name: 'Nombre Completo',
      email: 'Correo Electrónico',
      phone: 'Teléfono (opcional)',
      matter: 'Tipo de Consulta',
      matters: {
        immigration: 'Derecho de Inmigración',
        family: 'Derecho de Familia',
        retainr: 'RetainR',
        media: 'Medios / Conferencias',
        other: 'Otro',
      },
      message: 'Su Mensaje',
      messagePlaceholder: 'Describa brevemente su asunto o solicitud…',
      send: 'Enviar Mensaje',
      sending: 'Enviando…',
      successTitle: 'Mensaje Recibido',
      successBody: 'Gracias — su mensaje ha sido entregado a kenneth@KCRedding.com.',
      another: 'Enviar otro mensaje',
      error: 'Algo salió mal. Intente de nuevo o escriba directamente por correo.',
    },
    retainr: {
      label: 'Fundador · Tecnología Legal',
      heading: 'Prepare Su Caso Antes de Contratar a un Abogado',
      featuresLabel: 'Qué Hace RetainR',
      mattersLabel: 'Diseñado Para',
      visit: 'Visitar RetainR.com',
      founderNote: 'Fundado por Kenneth Christopher “KC” Redding',
      mediaLabel: 'Courtside with KC',
      mediaHeading: 'El Derecho, Explicado Desde el Tribunal',
      mediaSub: 'Siga a @CourtsidewithKC en Instagram, YouTube y TikTok para perspectivas legales en lenguaje claro sobre inmigración, derecho de familia y la vida en la sala del tribunal.',
      follow: 'Seguir',
    },
    resumeChoose: 'Elegir un currículum',
  },
  pt: {
    nav: {
      biography: 'Biografia',
      experience: 'Experiência',
      practice: 'Áreas de Atuação',
      writing: 'Amostras Jurídicas',
      credentials: 'Credenciais',
      organizations: 'Organizações',
      retainr: 'RetainR e Mídia',
      contact: 'Contato',
    },
    intro: {
      credential: 'Imigração e Direito de Família · Defesa contra Deportação',
      tagline: 'O Arquiteto da Advocacia',
      skip: 'Pular',
      enter: 'Entrar',
      soundOn: 'Som Ligado',
      soundOff: 'Som Desligado',
      soundHint: 'Melhor experiência com som',
    },
    hero: {
      label: 'Imigração e Direito de Família',
      cta: 'Ver Amostras Jurídicas',
      scroll: 'Rolar',
      quickAccess: 'Acesso Rápido',
      cards: {
        biography: 'Biografia',
        writing: 'Amostras',
        resume: 'Currículo',
        contact: 'Contato',
      },
    },
    bio: {
      label: 'Biografia',
      heading: 'O Caso pela Prática Deliberada',
      tagsLabel: 'Especialidades',
      languagesLabel: 'Idiomas',
    },
    experience: {
      label: 'Experiência Jurídica',
      heading: 'Uma Trajetória Feita de Casos Reais',
      subheading: 'Vinte e quatro comparências no tribunal de imigração, mais de 500 decisões redigidas para o 15º Circuito Judicial e experiência anterior em uma promotoria e na equipe de políticas de um governador.',
    },
    practice: {
      label: 'Áreas de Atuação',
      heading: 'Onde o Trabalho Acontece',
      subheading: 'Quatro disciplinas entrelaçadas, um método unificado de advocacia.',
    },
    writing: {
      label: 'Amostras Jurídicas',
      heading: 'Redigido. Revisado. Defendido.',
      subheading: 'Uma seleção de redação jurídica — petições, memorandos e apelações.',
      download: 'Baixar',
      comingSoon: 'Em Breve',
      featured: 'Destaque',
    },
    credentials: {
      label: 'Credenciais e Formação',
      heading: 'Educação, Certificações e Habilidades',
      education: 'Educação',
      trainings: 'Formações e Certificações',
      skills: 'Habilidades Jurídicas',
      litigation: 'Defesa contra Deportação e Litigância',
      research: 'Pesquisa & Redação',
      clientAdvocacy: 'Advocacia ao Cliente',
    },
    orgs: {
      label: 'Organizações e Pro Bono',
      heading: 'Serviço Além da Sala de Aula',
      memberships: 'Filiações',
      proBono: 'Compromissos Pro Bono',
      types: {
        Professional: 'Profissional',
        Academic: 'Acadêmica',
        Advocacy: 'Defesa',
      },
    },
    footer: {
      label: 'Contratar Advogado',
      heading: 'Obtenha uma Representação Criteriosa',
      emailLabel: 'Correspondência Direta',
      phoneLabel: 'Telefone',
      locationLabel: 'Escritórios',
      roleLabel: 'Atuação',
      roleValue: 'Imigração e Direito de Família',
      barLabel: 'Fundador',
      barValue: 'RetainR — Plataforma Legal-Tech',
      followLabel: 'Courtside with KC',
      contactCta: 'Enviar uma Mensagem',
      rights: 'Todos os Direitos Reservados',
    },
    contact: {
      label: 'Contato',
      heading: 'Comece a Conversa',
      subheading: 'Imigração, direito de família, RetainR ou mídia — cada mensagem é lida pessoalmente.',
      directLabel: 'Correspondência Direta',
      responseNote: 'Resposta normalmente em um dia útil.',
      name: 'Nome Completo',
      email: 'E-mail',
      phone: 'Telefone (opcional)',
      matter: 'Natureza da Consulta',
      matters: {
        immigration: 'Direito de Imigração',
        family: 'Direito de Família',
        retainr: 'RetainR',
        media: 'Mídia / Palestras',
        other: 'Outro',
      },
      message: 'Sua Mensagem',
      messagePlaceholder: 'Descreva brevemente seu assunto ou pedido…',
      send: 'Enviar Mensagem',
      sending: 'Enviando…',
      successTitle: 'Mensagem Recebida',
      successBody: 'Obrigado — sua mensagem foi entregue a kenneth@KCRedding.com.',
      another: 'Enviar outra mensagem',
      error: 'Algo deu errado. Tente novamente ou envie um e-mail diretamente.',
    },
    retainr: {
      label: 'Fundador · Tecnologia Jurídica',
      heading: 'Prepare Seu Caso Antes de Contratar um Advogado',
      featuresLabel: 'O Que o RetainR Faz',
      mattersLabel: 'Criado Para',
      visit: 'Visitar RetainR.com',
      founderNote: 'Fundado por Kenneth Christopher “KC” Redding',
      mediaLabel: 'Courtside with KC',
      mediaHeading: 'O Direito, Explicado de Dentro do Tribunal',
      mediaSub: 'Siga @CourtsidewithKC no Instagram, YouTube e TikTok para insights jurídicos em linguagem simples sobre imigração, direito de família e a vida no tribunal.',
      follow: 'Seguir',
    },
    resumeChoose: 'Escolher um currículo',
  },
};

export default t;
